/* eslint-disable jsx-a11y/anchor-is-valid */
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {FC, useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

import Deleteparty from '../../../DeleteTransactions'
import TransactionsDetails from '../../../TransactionsDetails'
import {ID} from 'src/_metronic/helpers'
import {MenuComponent} from 'src/_metronic/assets/ts/components'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  id: ID
  values: any
  data: any
}

const TransactionsActionsCell: FC<Props> = ({id, data}) => {
  const {setItemIdForUpdate} = useListView()
//console.log("Message ID -->> ",id)
  const [ShowDeleteTransactionsModal, setShowDeleteTransactionsModal] = useState<any>(false)
  const [ShowTransactionsDetailsModal, setShowTransactionsDetailsModal] = useState<boolean>(false)

  const [isActive, setIsActive] = useState(data.is_active)
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const cityList = useSelector((state: any) => state.commonList.cityList)
  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2
  const isTransactionsViewPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_view === true

  const isTransactionsDeletePermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_delete === true
  const isTransactionsEditPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_edit === true

  useEffect(() => {
    setIsActive(data.is_active)
  }, [data.is_active])

  const openEditTransactionsModal = () => {
    setItemIdForUpdate(id)
  }

  return (
    <div>
      <a className='menu-link ' onClick={() => setShowDeleteTransactionsModal(true)}>
        <OverlayTrigger
          placement='top'
          overlay={<Tooltip className='py-2 px-2 fs-5 '>Delete</Tooltip>}
        >
          <i className='fa-solid fa-trash fs-4 text-danger'></i>
        </OverlayTrigger>
      </a>
      <Deleteparty
        show={ShowDeleteTransactionsModal}
        handleClose={() => setShowDeleteTransactionsModal(false)}
        id={id}
      />
    </div>
  )
}

export {TransactionsActionsCell}
